<template>
  <section class="bg-gray-light">
    <div class="container">
      <div class="row my-3">
        <div class="col">
          <h1>{{ $t("translation.Plan_du_site") }}</h1>
          <ul>
            <li class="nav-item mr-1">
              <router-link class="nav-link " to="/">
                {{ $t("translation.Accueil") }}
              </router-link>
            </li>
            <li class="nav-item ">
              <router-link class="nav-link " to="/contact">
                {{ $t("translation.Contact") }}
              </router-link>
            </li>
            <li class="nav-item ">
              <router-link class="nav-link " to="/partners">
                {{ $t("translation.Partenaires") }}
              </router-link>
            </li>

            <li class="nav-item ">
              <router-link class="nav-link " to="/agence">
                {{ $t("translation.Lagence") }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "account",
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
@import "../scss/styles.scss";
section {
  padding-bottom: 50px;
  padding-top: 40px;
}
.nav-link {
  color: #ee064b;
  font-family: $font-nunito;
  font-size: 16px;
}
</style>
